module.exports = __webpack_public_path__ + "media/images/icons/eye_icon-fa07a04ae8c170061f3183ecfaeaacf3.svg";